import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';
import { getTenantConfig } from '../../utils/tenant';
import ConfirmDialog from '../../common/ConfirmDialog';

export default class SelectAllCheckbox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isMaxStudentsDialogOpen: false
    }
  }

  /**
   * when "select all" is enabled, show the select all checkbox as checked when all items
   * are selected. when "select all" is disabled, show the select all checkbox as checked 
   * when every item on the current page of the table is selected.
   */
  get checked() {
    return this.props.selectedItemIds.length > 0 
      && (this.props.batchSelectAllEnabled
        ? this.props.selectedItemIds.length === this.props.totalItemCount
        : this.props.itemIds.every(
          student => this.props.selectedItemIds.includes(student)))
  }

  get maxStudentsReached() {
    return getTenantConfig('BATCH_ACTION_MAX_STUDENTS') !== null
            && this.props.totalItemCount > getTenantConfig('BATCH_ACTION_MAX_STUDENTS')
  }

  selectAllItems = (checked) => {
    if(checked 
      && this.props.batchSelectAllEnabled
      && this.maxStudentsReached){
        this.setState({ isMaxStudentsDialogOpen: true })
        return;
    }
    
    this.props.selectAllItems(checked, this.props.itemIds)
  }

  get batchMaxStudentsCount() {
    return getTenantConfig('BATCH_ACTION_MAX_STUDENTS').toLocaleString();
  }
  
  render() {
    return (
      <>
        <Checkbox ariaLabel={"Select all " + this.props.itemName}
                  checked={this.checked}
                  className='select-all' 
                  onChange={this.selectAllItems} /> 
        {this.props.batchSelectAllEnabled && this.maxStudentsReached &&
          <ConfirmDialog
                    appElementId="main-center"
                    isOpen={this.state.isMaxStudentsDialogOpen}
                    onConfirm={() => {
                      this.setState({ isMaxStudentsDialogOpen: false })
                    }}
                    confirmText="Back to List"
                    headerText="We're sorry, but your list exceeds system limitations."
                    descriptionText={`We suggest filtering your list to fewer than ${this.batchMaxStudentsCount} before trying again to Select All`}
          />
        }
      </>
    )
  }
}

SelectAllCheckbox.defaultProps = {
  itemIds: [],
  batchSelectAllEnabled: false,
  selectedItemIds: []
}

SelectAllCheckbox.propTypes = {
  itemName: PropTypes.string.isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.number),
  batchSelectAllEnabled: PropTypes.bool, // this is terrible and should be removed once select all is turned on for everyone
  selectAllItems: PropTypes.func.isRequired,
  selectedItemIds: PropTypes.arrayOf(PropTypes.number),
  totalItemCount: PropTypes.number.isRequired
}
